import React from 'react';
import PropTypes from 'prop-types';
import {useTranslate} from '@computerrock/formation-i18n';
import {useStyles, Panel, DataRow, TextArea} from '@ace-de/ui-components';

const CostCoverageCostCoveragePanel = props => {
    const {cx} = useStyles();
    const {createTranslateShorthand} = useTranslate();
    const translateTab = createTranslateShorthand('sast_cost_coverage_tab');
    const {onChangeHandler, assignmentText} = props;

    return (
        <Panel
            title={translateTab('panel_title.cost_coverage')}
            qaIdent="sast-cost-coverage-cost-coverage"
        >
            <DataRow
                label={translateTab('data_row_label.description')}
                className={cx('ace-c-data-row--condensed')}
                qaIdent="sa-cost-coverage-description"
            >
                <TextArea
                    className={cx('global!ace-u-flex--grow-1')}
                    isResizable={false}
                    value={assignmentText}
                    onChange={value => onChangeHandler('assignmentText', value)}
                />
            </DataRow>
        </Panel>
    );
};

CostCoverageCostCoveragePanel.propTypes = {
    onChangeHandler: PropTypes.func.isRequired,
    assignmentText: PropTypes.string,
};

CostCoverageCostCoveragePanel.defaultProps = {
    assignmentText: '',
};

export default CostCoverageCostCoveragePanel;
